// extracted by mini-css-extract-plugin
module.exports = {"attachmentLineItem":"index_attachmentLineItem__2codn","attachmentName":"index_attachmentName__wA6jh","removeIcon":"index_removeIcon__1mWWn"};